import SidePanelHeader from "../components/SidePanelHeader"
import Form from "../../../entityComponents/Form/Form"
import { headerWidgetSignal, movingSidePanelSignal } from "../../Layout";
import { OuterCubeFullness } from "./SidePanelOuterCube";
import { EntityNames } from "../../../../../enums/EntityNames";

export default function SidePanelAddPackingBox({ data }: any) {

    function handleSubmissionCancelled() {
        movingSidePanelSignal.value = { ...movingSidePanelSignal.value, show: false, id: undefined };
    }

    async function onBoxAdded(data: any) {
        if (data) {
            headerWidgetSignal.value = <OuterCubeFullness amount={data.outerCubePercentageFull} />
        }
    }

    return (<>
        {data &&
            <>
                {<SidePanelHeader descriptor="Add New Packing Box" value="" statuses={[]} onClick={undefined} />}
                {data &&
                    <div className="margin__top--s">
                        <Form isCreate={true} 
                            entityName={data.entityName}
                            parentId={data.parentId}
                            parentEntityName={EntityNames.outerCubes}
                            isInline={true}
                            onCancel={handleSubmissionCancelled}
                            onSubmitCallback={onBoxAdded} />
                    </div>
                }
            </>
        }
    </>)
}